import { render, staticRenderFns } from "./AccesItem.vue?vue&type=template&id=06215f35&"
import script from "./AccesItem.vue?vue&type=script&lang=js&"
export * from "./AccesItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports